<template>
  <section>
    <b-button
      variant="outline-secondary"
      size="sm"
      class="mb-1"
      @click.prevent="
        $emit('view', { component: 'ListPengembalian', pengembalian: null })
      "
    >
      <feather-icon icon="ArrowLeftIcon" class="mr-50" />
      Kembali
    </b-button>

    <b-card class="mb-2">
      <small class="text-muted d-block mb-25">{{ item.no || "-" }}</small>
      <h4 class="mb-2">Detail Pengembalian</h4>
      <b-row>
        <b-col sm="6" md="4" lg="3" class="mb-1">
          <b-form-group label="Sales" class="mb-0">
            <strong>
              {{ item.sales ? item.sales.nama_lengkap : item.id_sales || "-" }}
            </strong>
          </b-form-group>
        </b-col>
        <b-col sm="6" md="4" lg="3" class="mb-1">
          <b-form-group label="Tanggal Request" class="mb-0">
            <strong>{{ humanDate(item.tanggal) }}</strong>
          </b-form-group>
        </b-col>
        <b-col sm="6" md="4" lg="3" class="mb-1">
          <b-form-group label="Tujuan Gudang" class="mb-0">
            <strong>
              {{
                item.gudang
                  ? item.gudang.nama_gudang
                  : item.id_gudang || "-"
              }}
            </strong>
          </b-form-group>
        </b-col>
        <b-col sm="6" md="4" lg="3" class="mb-1">
          <b-form-group label="Keterangan" class="mb-0">
            <strong>{{ item.keterangan || "-" }}</strong>
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>

    <h5 class="mb-1">
      Rincian Barang
      <span v-if="rincian.length">({{ rincian.length }})</span>
    </h5>
    <b-card>
      <div
        v-if="!rincian.length"
        class="text-center text-muted py-3"
      >
        Tidak ada rincian barang.
      </div>
      <b-table
        v-else
        responsive
        striped
        bordered
        small
        :fields="fields"
        :items="rincian"
      >
        <template #cell(no)="{ index }">
          {{ index + 1 }}
        </template>
        <template #cell(nama)="{ item }">
          <span v-if="item.barang">{{ item.barang.nama }}</span>
          <i v-else class="text-danger">Barang tidak ditemukan</i>
        </template>
        <template #cell(status)="{ item }">
          <feather-icon
            v-if="item.status && item.status.approve"
            size="20"
            icon="CheckCircleIcon"
            class="text-success"
          />
          <feather-icon
            v-else
            size="20"
            icon="XCircleIcon"
            class="text-danger"
          />
        </template>
        <template #cell(satuan)="{ item }">
          <span v-if="item.barang">
            {{
              item.barang.satuan ? item.barang.satuan.satuan : "-"
            }}
          </span>
          <i v-else class="text-danger">-</i>
        </template>
        <template #cell(action)="{ index, item }">
          <b-button
            v-if="
              isSales &&
                myGudang &&
                myGudang.id &&
                item.status &&
                !item.status.approve
            "
            size="sm"
            variant="outline-danger"
            v-b-tooltip.hover.top="'Hapus rincian'"
            @click.prevent="removeRincian(item, index)"
          >
            <feather-icon icon="TrashIcon" />
          </b-button>
          <feather-icon
            v-else
            icon="SlashIcon"
            size="18"
            class="text-secondary"
          />
        </template>
      </b-table>
    </b-card>
  </section>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormGroup,
  BTable,
  BButton,
  VBTooltip,
} from "bootstrap-vue";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BTable,
    BButton,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  props: ["pengembalian"],
  data() {
    return {
      item: {
        rincian: [],
      },
      fields: [
        { key: "no", label: "No" },
        { key: "nama", label: "Barang" },
        { key: "qty", label: "Qty Pengembalian" },
        { key: "satuan", label: "Satuan" },
        { key: "status", label: "Disetujui" },
        { key: "action", label: "Aksi" },
      ],
      confirmOption: {
        title: "Anda yakin?",
        text: "Rincian barang ini akan dihapus",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Ya",
        cancelButtonText: "Batal",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      },
    };
  },
  computed: {
    rincian() {
      return (this.item && this.item.rincian) || [];
    },
  },
  methods: {
    removeRincian(item, index) {
      this.$swal(this.confirmOption).then(async (res) => {
        if (!res.value) return;
        try {
          await this.$store.dispatch("pengembalianbarang/saveRincian", [
            {
              id: item.id,
              fungsi: 1,
            },
          ]);
          this.item.rincian.splice(index, 1);
          this.displaySuccess({ message: "Rincian berhasil dihapus" });
        } catch (e) {
          this.displayError(e);
        }
      });
    },
  },
  watch: {
    pengembalian: {
      immediate: true,
      handler(val) {
        if (val) {
          this.item = {
            ...val,
            rincian: Array.isArray(val.rincian) ? val.rincian : [],
          };
        }
      },
    },
  },
};
</script>
